import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { RootState } from "../../store";
import { AnyObject } from "../../../utils/basic";
import { getBestSellerProduct, getSaleDiscount, getScreensaverData, addFavourite, getFavourites, deleteFavourite } from "../../actions/customizer";
import { IFavourite } from "../../types/builder";
import AuthManager from "../../../utils/AuthManager";

export interface CustomizerState {
  data: null | AnyObject,
  isFetching: boolean;
  bestSellerProduct: null | AnyObject;
  screensaverData: null | AnyObject;
  favourites: IFavourite[];
  saleDiscount: number | null;
}

const initialState: CustomizerState = {
  data: null,
  isFetching: false,
  bestSellerProduct: null,
  screensaverData: null,
  favourites: [],
  saleDiscount: null,
}

export const customizerSlice = createSlice({
  name: 'customizer',
  initialState: initialState,
  reducers: {
    setProductData: (state: CustomizerState, action: PayloadAction<object>) => {
      state.data = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getBestSellerProduct.pending, (state) => {
      state.isFetching = true;
    });
    builder.addCase(getBestSellerProduct.fulfilled, (state, action) => {
      state.isFetching = false;
      state.bestSellerProduct = action.payload;
    })
    .addCase(getBestSellerProduct.rejected, (state) => {
      state.isFetching = false;
    });
    builder.addCase(getScreensaverData.fulfilled, (state, action) => {
      state.screensaverData = action.payload ?? null;
    });
    builder.addCase(getScreensaverData.rejected, (state) => {
      state.screensaverData = null;
    });

    builder.addCase(getSaleDiscount.fulfilled, (state, action) => {
      state.saleDiscount = action.payload;
    });

    builder.addCase(addFavourite.fulfilled, (state, action: any) => {
      AuthManager.setAnonymousUserIfNotExists(action.payload.user_id);
    });

    builder.addCase(getFavourites.fulfilled, (state, action: any) => {
      state.favourites = action.payload.data;
    });
    builder.addCase(getFavourites.rejected, (state, action: any) => {
      if (action?.payload?.status === 401) {
        state.favourites = [];
      }
    });

    builder.addCase(deleteFavourite.fulfilled, (state, action) => {
      const deletedUrl = action.meta.arg.product_url;
      state.favourites = state.favourites.filter(f => f.product_url !== deletedUrl);
    });
  }
});

export const { setProductData } = customizerSlice.actions;

const customizerReducer = customizerSlice.reducer;

export const selectProduct = (state: RootState) => {
  return state.customizer.data
}

export default customizerReducer
